__turbopack_context__.v({
  "chevron": "ChevronWithTooltip-module-sass-module__gaVueW__chevron",
  "chevron-stories-big": "ChevronWithTooltip-module-sass-module__gaVueW__chevron-stories-big",
  "stories-row": "ChevronWithTooltip-module-sass-module__gaVueW__stories-row",
  "tooltip-text": "ChevronWithTooltip-module-sass-module__gaVueW__tooltip-text",
});
